import React, { useEffect, useRef, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import axios from 'axios'
import { toast } from 'react-toastify'
import { Url } from '../../config/config'
import Modal from 'react-bootstrap/Modal'
import Multiselect from 'multiselect-react-dropdown'
import { Pdf, Jpg, Png, Jpeg } from '../../assets/icons'
import useFullPageLoader from '../../hooks/useFullPageLoader'
import DrawPolygon from '../DrawPolygon'

export default function UserDetails() {
  const [loader, showLoader, hideLoader] = useFullPageLoader()
  const [user, setUser] = useState({})
  const [cordinates, setCordinates] = useState([])
  const [iState, updateState] = useState({
    docId: '',
    action: '',
    partnerTypeValue: '',
    partnerValue: '',
  })

  const [errorField, setErrorField] = useState({
    partnerTypeValue: '',
    partnerValue: '',
  })

  const { docId, action } = iState
  const { id } = useParams()

  //***************User Details************** */
  const handelUserDetails = async () => {
    try {
      showLoader()
      const res = await axios({
        url: `${Url}/userDetails?userId=${id}`,
        method: 'GET',
      })
      hideLoader()
      if (res.status === 200) {
        setUser(res.data.data)

        let coordinates = res.data.data.coordinates
        let coorArray = []
        if (coordinates) {
          for (let i = 0; i < coordinates.length; i++) {
            coorArray.push([coordinates[i].lat, coordinates[i].lng])
          }
        }

        setCordinates(coorArray)
      }
      console.log('res', res.data.data)
    } catch (err) {
      console.log(err)
    }
  }

  //************Handel Action Request*********** */
  const [ActionModal, setActionModal] = useState(false)
  const handleActionRequestClose = () => {
    setActionModal(false)
  }
  const handleActionRequestOpen = (action, docId) => {
    updateState({ ...iState, docId: docId, action: action })
    setActionModal(true)
  }
  const handelActionRequest = async () => {
    try {
      // console.log(docId, action);
      const res = await axios({
        url: `${Url}/solarRequest`,
        method: 'PUT',
        data: {
          docsId: docId,
          state: action,
        },
      })
      // console.log(res.status);
      handleActionRequestClose()
      if (res.status === 200) {
        handelUserDetails()
        toast.success('Document status updated successfully')
      } else {
        toast.error('Something went to wrong')
      }
      console.log(res.data.data)
    } catch (err) {
      console.log(err)
    }
  } //*********Refer Action Modal********* */
  const [ReferActionModal, setReferActionModal] = useState(false)
  const [
    ReferToFincancialActionModal,
    setReferToFincancialActionModal,
  ] = useState(false)
  const [RequestType, setRequestType] = useState()
  const handelReferRequest = (type) => {
    setRequestType(type)
    setReferActionModal(true)
  }

  const handelReferRequestClose = () => {
    setReferActionModal(false)
  }

  const handelFinancialReferRequestClose = () => {
    setReferToFincancialActionModal(false)
  }

  const handelActionRequestType = () => {
    if (RequestType === 1) {
      handelReferRequestClose()
      setReferToFincancialActionModal(true)
    } else {
      //console.log("Api called");
      handelReferalByVoltAdmin()
    }
  }

  //**************Handel Partner Type List ******** */
  const [partnerType, setPartnerType] = useState([])
  const handelPartnerype = async () => {
    try {
      const res = await axios({
        url: `${Url}/solarRequest/financialPartner`,
        method: 'GET',
      })
      if (res.data.status === 200) {
        setPartnerType(res.data.data.partnerTypeList)
      } else {
        toast.error('Something went to wrong')
      }
    } catch (err) {
      console.log(err)
      toast.error('Something went to wrong')
    }
  }

  //*********Handel Financial Partner********* */
  const [financialPartner, setFinancialPartner] = useState([])

  const handelFinancialPartner = async (typeId) => {
    try {
      const res = await axios({
        url: `${Url}/solarRequest/selectType?financeCompanyType=${typeId}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        //data: data,
      })

      if (res.data.status === 200) {
        //console.log("mydata", res.data.data);
        //*****Set option values*** */
        let responseData = res.data.data
        var tempArray = []
        if (responseData.length > 0) {
          for (var i = 0; i < responseData.length; i++) {
            var array = {
              name: responseData[i].financeCompanyName,
              id: responseData[i]._id,
            }

            tempArray.push(array)
          }
        }
        setFinancialPartner(tempArray)
        //******End of Options**** */
      } else {
        toast.error('Something went to wrong')
      }
    } catch (err) {
      console.log(err)
      toast.error('Something went to wrong')
    }
  }

  const onSelect = (e) => {
    // console.log(e);
    updateState({ ...iState, partnerValue: e })
  }

  const onRemove = (e) => {
    //console.log("rem", e);
    updateState({ ...iState, partnerValue: e })
  }

  const resetDropdownValue = useRef()

  //*************** */
  const handelOnChange = (e) => {
    //reset selected value
    resetDropdownValue.current.resetSelectedValues()
    updateState({ ...iState, partnerTypeValue: e.target.value })
    handelFinancialPartner(e.target.value)
  }

  //*********Handel Validation********** */
  const handleValidation = () => {
    let errorField = {}
    let formIsValid = true
    if (!iState.partnerTypeValue) {
      errorField['partnerTypeValue'] = 'Please select Partner Type'
      formIsValid = false
    }

    if (!iState.partnerValue) {
      errorField['partnerValue'] = 'Please select Financial Partner'
      formIsValid = false
    }
    setErrorField(errorField)
    return formIsValid
  }
  //********Final Submit*********** */
  const handelRefralSubmit = async () => {
    try {
      if (handleValidation()) {
        let resData = iState.partnerValue
        let temp = []
        for (var j = 0; j < resData.length; j++) {
          temp.push(resData[j].id)
        }

        let data = {
          financialPartnerByName: temp,
          userId: id,
          RefertoFinancialPartner: 'ReferToFinance',
        }
        // console.log("data", data);
        //return false;
        console.log(data, data)
        const res = await axios({
          url: `${Url}/solarRequest/selectType`,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          data: data,
        })
        console.log('res', res)
        if (res.data.status === 200) {
          handelFinancialReferRequestClose()
          handelUserDetails()
          toast.success(res.data.message)
        } else {
          toast.error('Something went to wrong')
        }
      }
    } catch (err) {
      console.log(err)
      toast.error('Something went to wrong')
    }
  }

  //******Referal By Volt Admin******* */
  const handelReferalByVoltAdmin = async () => {
    try {
      // console.log(id);
      const res = await axios({
        url: `${Url}/solarRequest/refer`,
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        data: {
          userId: id,
          RefertoFinancialPartner: 'ReferToVolt',
        },
      })
      if (res.data.status === 200) {
        handelReferRequestClose()
        handelUserDetails()
        toast.success(res.data.message)
      }
    } catch (err) {
      toast.error('Something went to wrong')
    }
  }

  useEffect(() => {
    handelPartnerype()
    handelUserDetails()
  }, [])

  return (
    <React.Fragment>
      <title>User Details</title>
      <div className="WrapperArea">
        <div className="WrapperBox">
          {loader}
          <div className="Small-Wrapper">
            <h4 className="Title back_wrap">
              {' '}
              <Link to="/user" className="back_btn">
                <i className="fa fa-arrow-left"></i>
              </Link>
              User Details
            </h4>
            <div className="OrderArea">
              <table className="detail-table">
                <tbody>
                  <tr>
                    <td className="detail-label">User Name</td>
                    <td className="detail-value">
                      {user.firstName
                        ? (user.firstName + ' ' + user.lastName).trim()
                        : '- - -'}
                    </td>
                  </tr>
                  <tr>
                    <td className="detail-label">Company Name</td>
                    <td className="detail-value">{user.nameOfBusiness?.trim() || '- - -'}</td>
                  </tr>
                  <tr>
                    <td className="detail-label">Nature of Business</td>
                    <td className="detail-value">{user.natureOfTheBusiness?.trim() || '- - -'}</td>
                  </tr>
                  <tr>
                    <td className="detail-label">Contact Number</td>
                    <td className="detail-value">{user.contactNum || '- - -'}</td>
                  </tr>
                  <tr>
                    <td className="detail-label">Email Address</td>
                    <td className="detail-value">{user.email?.trim() || '- - -'}</td>
                  </tr>
                  <tr>
                    <td className="detail-label">Company Pan Number</td>
                    <td className="detail-value">{user.companyPan?.trim() || '- - -'}</td>
                  </tr>
                  <tr>
                    <td className="detail-label">Address</td>
                    <td className="detail-value">{user.address?.trim() || '- - -'}</td>
                  </tr>
                  <tr>
                    <td className="detail-label">Average of Monthly Bill</td>
                    <td className="detail-value">Rs {user.avgMonBill || '0'}</td>
                  </tr>
                  <tr>
                    <td className="detail-label">Average Annual Profit</td>
                    <td className="detail-value">Rs {user.AvgProfitlastFiveYear || '0'}</td>
                  </tr>
                  <tr>
                    <td className="detail-label">Plot Size of Facility</td>
                    <td className="detail-value">
                      {user.totalroofArea ? user.totalroofArea.toFixed(2) : 0} sqf
                    </td>
                  </tr>
                  <tr>
                    <td className="detail-label">Pre Approved Solar System</td>
                    <td className="detail-value">
                      {user.approvedSolarSystemOutput !== null
                        ? user.approvedSolarSystemOutput
                          ? user.approvedSolarSystemOutput.toFixed(2) + ' Kw'
                          : 'Not Eligible'
                        : 'Not Eligible'}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          {/* Mark of Roof area */}
          {/* <div className="Small-Wrapper">
            <h4 className="Title">
              Mark of Roof ({" "}
              {user.totalroofArea ? user.totalroofArea.toFixed(2) : 0} sqf)
            </h4>
           
          </div> */}
          {/* Document Details */}
          <div className="Small-Wrapper">
            <h4 className="Title">Document Uploaded </h4>
            <div className="OrderArea">
              <div className="row" style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', padding: '10px 0' }}>
                {user &&
                  user.docsData &&
                  user.docsData.length > 0 &&
                  user.docsData[0].map((item, i) => (
                    <div className="upload_card" key={i}>
                      <p>{item.documentName}</p>
                      <p>
                        {item.docsType === 'pdf' ? (
                          <img src={Pdf} height="50" width="50" alt="pdf" />
                        ) : item.docsType === 'jpg' ? (
                          <img src={Jpg} height="50" width="50" alt="jpg" />
                        ) : item.docsType === 'jpeg' ? (
                          <img src={Jpeg} height="50" width="50" alt="jpeg" />
                        ) : (
                          <img src={Png} height="50" width="50" alt="png" />
                        )}
                      </p>
                      <p>
                        <button
                          className="button"
                          onClick={() => window.open(item.imageUrl, '_blank')}
                        >
                          PREVIEW
                        </button>
                      </p>
                    </div>
                  ))}
              </div>
            </div>
          </div>
          {/* Action on Request */}
          {/* <div className="Small-Wrapper">
            <h4 className="Title">Actions On Request </h4>
            <div className="OrderArea">
              {user.state == "Pending" ? (
                <>
                  <button
                    className="btn button"
                    onClick={() => {
                      handleActionRequestOpen("Accepted", user._id);
                    }}
                  >
                    Accept
                  </button>
                  <button
                    className="btn button"
                    onClick={() => {
                      handleActionRequestOpen("Rejected", user._id);
                    }}
                  >
                    Reject
                  </button>
                </>
              ) : (
                <>
                  {user.state === "Accepted" ? (
                    <>
                      {user.RefertoFinancialPartner === "ReferToFinance" ? (
                        <div>
                          This application has been successfully Financed by the
                          Financial Partner
                        </div>
                      ) : (
                        <>
                          {user.RefertoFinancialPartner === "ReferToVolt" ? (
                            <div>
                              This application has been successfully Financed by
                              VOLT admin
                            </div>
                          ) : (
                            <>
                              <strong>
                                This Application has been successfully accepted
                                by Volt admin
                              </strong>
                              <br></br>
                              <button
                                className="btn button"
                                onClick={() => {
                                  handelReferRequest(1);
                                }}
                              >
                                Refer to Financial Partner
                              </button>
                              <button
                                className="btn button"
                                onClick={() => {
                                  handelReferRequest(2);
                                }}
                              >
                                Financed By VOLT
                              </button>
                            </>
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <strong>
                      {user.state === "Rejected"
                        ? "This Application has been successfully rejected by Volt admin"
                        : ""}
                    </strong>
                  )}
                </>
              )}
            </div>
          </div> */}
          {user.state === 'Pending' ? (
            <div className="Small-Wrapper">
              <div className="OrderArea">
                <strong>
                  Note:-Once any action taken on the request, admin would not
                  able to change the taken action again
                </strong>
              </div>
            </div>
          ) : null}
        </div>
      </div>
      {/* Popup model handel action request status */}
      <Modal show={ActionModal} onHide={handleActionRequestClose}>
        <Modal.Header closeButton onClick={handleActionRequestClose}>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure want to{' '}
          <strong>{action === 'Accepted' ? 'Accept' : 'Reject'}</strong> the
          document status of <strong>{user.nameOfBusiness} </strong>?
        </Modal.Body>
        <Modal.Footer>
          <button variant="secondary" onClick={handleActionRequestClose}>
            No
          </button>
          <button variant="primary" onClick={handelActionRequest}>
            Yes
          </button>
        </Modal.Footer>
      </Modal>

      {/* Refer to Financial Partner */}
      <Modal show={ReferActionModal} onHide={handelReferRequestClose}>
        <Modal.Header closeButton onClick={handelReferRequestClose}>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {RequestType === 1
            ? 'Are you sure want to refer to Refer to Financial Partner'
            : 'Are you sure want to Financed By VOLT'}
        </Modal.Body>
        <Modal.Footer>
          <button variant="secondary" onClick={handelReferRequestClose}>
            No
          </button>
          <button variant="primary" onClick={handelActionRequestType}>
            Yes
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={ReferToFincancialActionModal}
        onHide={handelFinancialReferRequestClose}
      >
        <Modal.Header closeButton onClick={handelFinancialReferRequestClose}>
          <Modal.Title>Refer to Financial Partner</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-6">
              <select
                className="form-control"
                name="partnerType"
                onChange={(e) => {
                  handelOnChange(e)
                }}
              >
                <option>Select Type</option>
                {partnerType &&
                  partnerType.length > 0 &&
                  partnerType.map((type, i) => (
                    <option key={i} value={type._id}>
                      {type.financeCompanyType}
                    </option>
                  ))}
              </select>
              <span style={{ color: 'red' }} className="error">
                {errorField.partnerTypeValue}
              </span>
            </div>
            <div className="col-md-6">
              <Multiselect
                options={financialPartner}
                selectedValues=""
                ref={resetDropdownValue}
                onSelect={(e) => {
                  onSelect(e)
                }}
                onRemove={(e) => {
                  onRemove(e)
                }}
                displayValue="name"
              />
              <span style={{ color: 'red' }} className="error">
                {errorField.partnerValue}
              </span>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button variant="primary" onClick={handelRefralSubmit}>
            Submit
          </button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  )
}
